<div *ngIf="isEmpty" class="empty-state">
  Map at least one field to see the preview
</div>

<div *ngIf="!isEmpty" class="tree-root" [class.nested]="depth > 0">
  <div *ngFor="let node of visibleNodes" class="tree-item-wrap">
    <div class="tree-item">
      <div class="tree-dot" [style.background]="node.dot"></div>
      <span class="tree-text" [class.bold]="node.bold">{{ node.text }}</span>
      <span class="tree-tag">{{ node.tag }}</span>
    </div>

    <app-tree-preview
      *ngIf="(showAll || depth > 0) && node.children && node.children.length > 0"
      [nodes]="node.children"
      [depth]="depth + 1"
      class="subtree"
      [style.border-left-color]="node.dot + '44'"
    ></app-tree-preview>
  </div>

  <button
    *ngIf="showExpandButton"
    class="expand-btn"
    (click)="showAll = !showAll"
  >
    <svg [class.flipped]="showAll" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  </button>
</div>
